import { createRouter, createWebHistory } from 'vue-router'
import RemoveBG from '@/components/RemoveBG.vue'
import RemoveBGPrivacy from '@/views/RemoveBGPrivacy.vue'
import RemoveBGTerms from '@/views/RemoveBGTerms.vue'
import PicturePage from '@/views/PicturePage.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: RemoveBG
  },
  {
    path: '/remove_bg',
    name: 'RemoveBGHome',
    component: PicturePage
  },
  {
    path: '/remove_bg_privacy',
    name: 'RemoveBGPrivacy',
    component: RemoveBGPrivacy
  },
  {
    path: '/remove_bg_terms',
    name: 'RemoveBGTerms',
    component: RemoveBGTerms
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router

